import axios from 'axios';
import getUrl from 'utils/getUrl';
import { toApiBlockFormat } from 'sharedParts/api/dataMapper/blockDataMapper';
import { generateApiError } from './utils/apiErrorMessages';
import changeRedirectUrlSubmissionError from './submissionErrors/changeRedirectUrlSubmissionError';

const updateBlock = (collectionPath, entityId, { itemId, blockData }) =>
  axios
    .patch(getUrl.apiV2(`${collectionPath}/${entityId}/items/${itemId}`), {
      ...toApiBlockFormat(blockData),
    })
    .catch(
      generateApiError({
        submissionErrorMap: changeRedirectUrlSubmissionError,
      }),
    );

export default updateBlock;
